import React from "react";
import { toast } from "react-toastify";
import "./pwa.css";

function UpdateMessage() {
  return (
    <div className="pwa-update">
      <span>There's a new version of ANNA.</span>
      <button
        type="button"
        className="pwa-update-btn"
        onClick={(event) => {
          event.stopPropagation();
          window.location.reload();
        }}
      >
        Refresh
      </button>
    </div>
  );
}

/** Asks for a refresh after a deploy. Stays until tapped or closed; shows once. */
export function showUpdateToast() {
  toast.info(<UpdateMessage />, {
    toastId: "anna-update",
    autoClose: false,
    closeOnClick: false,
    draggable: false,
  });
}
